import moment from 'moment';

export const ageAddPreText = (ageStr: string) => {
  return 'Age ' + ageStr;
};

const hasMetricValue = (value: unknown): boolean => {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  return !Number.isNaN(Number(value));
};

const hasTrendData = (list: any[]): boolean => {
  if (!Array.isArray(list) || list.length === 0) {
    return false;
  }
  return list.some(
    item =>
      Array.isArray(item?.metrics) &&
      item.metrics.some((metric: any) => hasMetricValue(metric?.value)),
  );
};

/** Sensor Tower 详情用户画像：指标卡、性别/年龄图表均无有效数据 */
export const isDemographicsDetailDataEmpty = (data: any): boolean => {
  if (!data) {
    return true;
  }
  const metrics = data?.metrics;
  const hasMetrics =
    Array.isArray(metrics) &&
    metrics.some((item: any) => hasMetricValue(item?.value));
  return !hasMetrics && !hasTrendData(data?.gender_trend) && !hasTrendData(data?.age_trend);
};

export const getQuarterDateRange = (
  quarterDate: string,
): { start_date: string; end_date: string } | null => {
  const dateM = moment(quarterDate);
  if (!dateM.isValid()) {
    return null;
  }
  return {
    start_date: dateM.clone().startOf('quarter').format('YYYY-MM-DD'),
    end_date: dateM.clone().endOf('quarter').format('YYYY-MM-DD'),
  };
};

export const transValueFormat = (floatNum: number) => {
  if (floatNum === null || isNaN(floatNum)) {
    return '-';
  }
  return (floatNum * 100).toFixed(1);
};
export const transValueFormatGrowth = (floatNum: number) => {
  if (isNaN(floatNum)) {
    return '-';
  }
  return transValueFormat(Math.abs(floatNum)) + '%';
};
